export const isComponentCalculator = (compProps) => {
    if ('isCalculator' in compProps) {
        return compProps.isCalculator
    }

    return false
}